import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { Language, LanguagePair } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TData = {
  allOrderableSourceLanguages: Language[];
  allOrderableTargetLanguages: Language[];
  languagePairs: LanguagePair[];
};

export const useLanguages = (
  options: Omit<UseQueryOptions<unknown, TGenericError, TData>, 'queryKey'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    query languages {
      clientAccount {
        allOrderableSourceLanguages {
          code
        }
        allOrderableTargetLanguages {
          code
        }
        languagePairs {
          sourceLanguageCode
          targetLanguageCode
        }
      }
    }
  `;

  return useQuery<unknown, TGenericError, TData>({
    ...options,
    queryKey: ['useLanguages'],
    queryFn: async () =>
      client.request({
        data: {
          gql: graphql
        }
      })
  });
};
